<app>
  <spinner />
  
  <div class="d-flex">
    <div class="w-30">
      <search
        criteria={state.criteria}
        results={state.results}
        on-input={onInput}
      />
    </div>
    <div class="w-70 ml-5">
      <template if={state.results}>
        <div class="d-flex flex-wrap">
          <div>
            <span class="fw-bold">{state.results.total}&nbsp;</span>
            {cap(t('hits'))}
          </div>

          <watchlist-filter
            class="ml-5 text-nowrap"
            criteria={state.criteria}
            on-input={onInput}
          />

          <dfk-pagination
            class="ml-auto"
            page={state.results.page}
            per-page={state.results.perPage}
            total={state.results.total}
            page-to={onInput}
            first-label={t('first_page')}
            previous-label={t('prev_page')}
            next-label={t('next_page')}
            last-label={t('last_page')}
          />
        </div>
        
        <results
          results={state.results}
          on-input={onInput}
        />
      </template>
    </div>
  </div>

  <script>
    import {UrlSearch, Url} from '@wendig/lib'
    import search from '../lib/search.instance'
    import {indexFor, params} from '../lib/util'

    export default class {
      constructor() {
        this.onSearch = this.onSearch.bind(this)
        this.urlSearch = new UrlSearch(this, {
          getParams: params,
          switches: ['favorites']
        })
      }

      onBeforeMount() {
        this.urlSearch.setup()
        this.on('watchlist-changed', event => this.onInput({}))
      }


      onSearch(p) {
        search.articles(p).then(data => {
          this.update({
            results: data
          })
        })
      }
    }
  </script>
</app>
